// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/calendar_day.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";
import { file_studyo_today_schedules_v1_resources_calendar_period } from "./calendar_period_pb.js";
import { file_studyo_today_schedules_v1_resources_day_annotation } from "./day_annotation_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/resources/calendar_day.proto.
 */
export const file_studyo_today_schedules_v1_resources_calendar_day = /*@__PURE__*/
  fileDesc("CjZzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9jYWxlbmRhcl9kYXkucHJvdG8SI3N0dWR5by50b2RheS5zY2hlZHVsZXMudjEucmVzb3VyY2VzItcCCgtDYWxlbmRhckRheRIeCgNkYXkYASABKAsyES5nb29nbGUudHlwZS5EYXRlEhgKEGN5Y2xlX2RheV9udW1iZXIYAiABKAUSFgoOY3ljbGVfZGF5X25hbWUYAyABKAkSRwoLYW5ub3RhdGlvbnMYBCADKAsyMi5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5EYXlBbm5vdGF0aW9uEkQKB3BlcmlvZHMYBSADKAsyMy5zdHVkeW8udG9kYXkuc2NoZWR1bGVzLnYxLnJlc291cmNlcy5DYWxlbmRhclBlcmlvZBIbChNsb25nX2N5Y2xlX2RheV9uYW1lGAYgASgJEiUKHWlzX2RheV9vZl93ZWVrX2N5Y2xlX2RheV9uYW1lGAcgASgIEiMKG2N5Y2xlX2RheV9zY2hlZHVsZV9jeWNsZV9pZBgIIAEoCUIrqgIoU3R1ZHlvLlRvZGF5LlNjaGVkdWxlcy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_google_type_date, file_studyo_today_schedules_v1_resources_calendar_period, file_studyo_today_schedules_v1_resources_day_annotation]);

/**
 * Describes the message studyo.today.schedules.v1.resources.CalendarDay.
 * Use `create(CalendarDaySchema)` to create a new message.
 */
export const CalendarDaySchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_calendar_day, 0);

